import React from 'react';
import { Uploader } from './Uploader';
import { createOrgFiles } from '../vanilla_actions';

const OrgUploaderApp = props => (
  <Uploader
    forOrg
    createFiles={createOrgFiles}
    canSetCover={false}
    {...props}
  />
);

export default OrgUploaderApp;
